import Vue from 'vue'
import Vuex from 'vuex'
import authStore from './modules/auth'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        authStore
    },
    strict: debug,
    plugins: [createPersistedState({
        key: 'storeAuth'
    })]
})
